import React, { useEffect } from 'react';
import { Wrapper, Title } from './styled';
import { useDispatch, useSelector } from 'react-redux';
import { selectAgentExecutionSelected, selectResultExecutions } from 'store/Agents/selectors';
import Result from './Result';
import { getResultsExecutions } from 'store/Agents/actions';
import { get } from 'lodash';

const Results = () => {
  const dispatch = useDispatch();
  const results = useSelector(selectResultExecutions);
  const agentExecutionSelected = useSelector(selectAgentExecutionSelected);
  const workspacesCommands = get(agentExecutionSelected, '[0].parameters_data.workspaces_commands', []);

  useEffect(() => {
    dispatch(getResultsExecutions(workspacesCommands));
  }, [dispatch, workspacesCommands]);

  return (
    <Wrapper>
      <Title children='Findings' />
      {results.map((e, index) =>
        <Result key={ index } data={ e } />
      )}
    </Wrapper>
  );
};

export default Results;
